import { createEntity } from "shadow-client";

export const identificator = createEntity("identificators", {});



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/accessControlApi/schemas.js